import { Tray } from '@models/tray.model';
import { Plant } from '@models/plant.model';

export class Lift {
    public id: number;
    public name: string;
    public trays: Tray[];
    public plant: Plant;

    constructor(lift: any = {}) {
        this.id = lift.id || 0;
        this.name = lift.name || '';
        this.trays = lift.trays ? lift.trays.map((tray) => new Tray(tray)) : [];
        this.plant = lift.plant ? new Plant(lift.plant) : null;
    }

    get type() {
        return 'lift';
    }
}
